export function getEnviroment({ prod, develop, test }){
    
    const development = ['development', 'dev', 'homolog'].includes(process.env.VUE_APP_NODE_ENV);
    const production = ['production', 'prod'].includes(process.env.VUE_APP_NODE_ENV);
    const local = ['local', 'localhost'].includes(process.env.VUE_APP_NODE_ENV);
    
    if (production) return prod;
    if (development) return develop;
    if (local) return test;
    
    return test;
  }
  